import React from "react";
import { LucideIcon } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export interface MetricProps {
  statValue: number | string;
  metricTitle: string;
  icon?: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
  isLoading?: boolean;
}

export const StatMetric: React.FC<MetricProps> = ({
  statValue,
  metricTitle,
  icon: Icon,
  iconColor = "text-white",
  iconBgColor = "bg-slate-500",
  isLoading = false,
}) => {
  return (
    <article className="min-w-48 rounded-lg border border-slate-300 bg-white p-6">
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-slate-600">{metricTitle}</h3>
          {Icon && (
            <div className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${iconBgColor}`}>
              <Icon className={`h-4 w-4 ${iconColor}`} />
            </div>
          )}
        </div>
        <div className="mt-3">
          {isLoading ? <Skeleton className="h-8 w-16" /> : <h5 className="text-2xl font-semibold text-black">{statValue}</h5>}
        </div>
      </div>
    </article>
  );
};
